var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"grey lighten-5"},[_c('div',{staticClass:"pa-2 ml-3"},[_c('v-row',[_c('v-col',[_c('div',[_vm._v(_vm._s(_vm.factor.name)+" "+_vm._s(_vm.factor.type))])])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }